export default __webpack_public_path__ + "static/media/feature_image_2.69a1d471.png";